<template>
	<v-app>
		<v-app-bar app>
			<v-toolbar class="white">
				<img alt="Vue logo" src="./assets/ggm_logo_mini.jpg">
				<v-toolbar-title class="indigo--text text--darken-2 ma-7 font-italic" style="width: 105px;">DATABASE
				</v-toolbar-title>
			</v-toolbar>
		</v-app-bar>

		<v-content class="white">
			<Formulaire/>
		</v-content>
	</v-app>
</template>

<script src="/dist/vue-add-to-calendar.min.js"></script>
<script>
	import Formulaire from './components/Formulaire'

	export default {
		name: 'App',
		components: {
			Formulaire,
		},
	};
</script>
